import { AuthApi } from './auth-api.ts';
import { ChallengeConfigsApi } from './challenge-configs-api.ts';
import { CommonApi } from './common-api.ts';
import { CoursesApi } from './courses-api.ts';
import { DevicesApi } from './devices-api.ts';
import { GameSessionsApi } from './game-sessions-api.ts';
import { IGolfApi } from './iGolf-api.ts';
import { instanceCore } from './instances.ts';
import { PartnersApi } from './partners-api.ts';
import { ClientPerformanceAggregation } from './performance/client-aggregation/index.ts';
import { PerformanceApi } from './performance/performance-api.ts';
import { PlayersApi } from './players-api.ts';
import { PromoCodesApi } from './promo-codes-api.ts';
import { queryClient } from './query-client.ts';
import { UsersApi } from './users-api.ts';

const authApi = new AuthApi(instanceCore);
const partnersApi = new PartnersApi(instanceCore);
const commonApi = new CommonApi(instanceCore);
const coursesApi = new CoursesApi(instanceCore);
const usersApi = new UsersApi(instanceCore);
const playersApi = new PlayersApi(instanceCore);
const promoCodesApi = new PromoCodesApi(instanceCore);
const devicesApi = new DevicesApi(instanceCore);
const iGolfApi = new IGolfApi(instanceCore);
const gameSessionsApi = new GameSessionsApi(instanceCore);
const challengeConfigsApi = new ChallengeConfigsApi(instanceCore);
const performanceApi = new PerformanceApi(
  new ClientPerformanceAggregation(coursesApi, challengeConfigsApi, queryClient)
);
export const API = {
  promoCodes: promoCodesApi,
  challengeConfigs: challengeConfigsApi,
  auth: authApi,
  partners: partnersApi,
  common: commonApi,
  courses: coursesApi,
  users: usersApi,
  players: playersApi,
  devices: devicesApi,
  iGolf: iGolfApi,
  gameSessions: gameSessionsApi,
  performance: performanceApi,
};
